/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from 'lodash';
/**
 * This components is a simple wrapper around a search bar.
 *
 * @vue-prop {String} [placeholder] the search placeholder
 * @vue-prop {Boolean|Array|String|Object} [results] the search result set
 * @vue-prop {Boolean} [showNoResult=true] whether to show a notice of no results or not
 * @vue-prop {String} [rules] search validator rules
 *
 * @vue-slot [no-result] a message to display when there are no results
 *
 * @category ui.components.form-elements
 * @exports SearchBar
 * @component
 */
const __vue_script__ = {
    name: 'SearchBar',

    props: {
        value: {
            type: String,
            default: null
        },

        placeholder: {
            type: String,
            default: null
        },

        results: {
            type: [Boolean, Array, String, Object],
            default: () => []
        },

        showNoResult: {
            type: Boolean,
            default: true
        },

        rules: {
            type: String,
            default: null
        },

        debounceInputEvent: {
            type: Number,
            default: null
        },
    },

    data() {
        const phKey = this.rules && this.rules.includes('email') ? 'search_email' : 'search';

        return {
            innerValue: this.value || '',
            searchPlaceholder: this.placeholder || this.$i18n.t(`general.${phKey}`)
        };
    },

    computed: {
        /**
         * Checks if the search returned valid results
         *
         * @returns {Boolean} true if the results set is not empty
         */
        hasResult() {
            if (typeof this.results === 'boolean') {
                return this.results;
            }

            if (this.results && typeof this.results === 'object') {
                return Boolean(Object.keys(this.results).length);
            }

            return Boolean(this.results && this.results.length);
        }
    },

    watch: {
        innerValue() {
            if (!this.innerValue || !this.innerValue.length) {
                this.$refs.validator.reset();
                this.$emit('cleared');
            }
        }
    },

    created() {
        this.emitChange = debounce((value) => {
            this.$emit('input', value);
        }, this.debounceInputEvent);
    },

    methods: {
        /**
         * Resets the search term.
         */
        clear() {
            this.innerValue = '';
            this.input();
        },

        /**
         * Triggered when user interacts with input components.
         */
        input() {
            if (this.debounceInputEvent) {
                this.emitChange(this.innerValue);
            } else {
                this.$emit('input', this.innerValue);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-bar"},[_c('validation-provider',{ref:"validator",staticClass:"search-input-wrapper",attrs:{"tag":"div","name":"search","rules":_vm.rules,"skip-if-empty":false,"mode":"lazy"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('i',{class:[_vm.value.length > 0 ? 'ic-x' : 'ic-search'],on:{"click":function($event){return _vm.clear()}}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.innerValue),expression:"innerValue"}],attrs:{"type":"search","placeholder":_vm.searchPlaceholder,"autocomplete":"new"},domProps:{"value":(_vm.innerValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.innerValue=$event.target.value},_vm.input]}}),(errors.length)?_c('p',{staticClass:"help error"},[_vm._v(_vm._s(errors[0]))]):_vm._e()]}}])}),_vm._t("default"),(_vm.showNoResult && !_vm.hasResult && _vm.innerValue.length !== 0)?_c('div',{staticClass:"no-results"},[(!_vm.hasResult && !_vm.$slots['no-results'])?_c('i18n',{attrs:{"path":"general.empty","tag":"p"}},[_c('strong',[_c('em',[_vm._v(_vm._s(this.innerValue))])])]):_vm._e(),_vm._t("no-results")],2):_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SearchBar.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__